import { ACTION_TYPES, ContainerWidth } from 'store/layout/types';

export const setContainerWidth = (width: ContainerWidth) => ({
  type: ACTION_TYPES.SET_CONTAINER_WIDTH,
  payload: width,
});

export const resetContainerWidth = () => ({
  type: ACTION_TYPES.SET_CONTAINER_WIDTH,
  payload: 'lg',
});
